"use strict";
/** The points of the origin element and the overlay element to connect. */
var ConnectionPositionPair = (function () {
    function ConnectionPositionPair(origin, overlay) {
        this.originX = origin.originX;
        this.originY = origin.originY;
        this.overlayX = overlay.overlayX;
        this.overlayY = overlay.overlayY;
    }
    return ConnectionPositionPair;
}());
exports.ConnectionPositionPair = ConnectionPositionPair;
//# sourceMappingURL=connected-position.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@angular2-material/core/overlay/position/connected-position.js
 ** module id = 912
 ** module chunks = 2
 **/